// Convert the array into a JSON object with the timestamp as the key
export const groupLgvsByTimeFrame = (dataArr) => {
  return dataArr.reduce((acc, item) => {
    const { timestamp, vehicleNumber } = item;

    if (!acc[timestamp]) {
      acc[timestamp] = [];
    }

    const vehicleExists = acc[timestamp].some(
      (entry) => entry.vehicleNumber === vehicleNumber
    );

    if (!vehicleExists) {
      acc[timestamp].push({ ...item });
    }

    return acc;
  }, {});
};

export const groupDockByTimeFrame = (dataArr) => {
  return dataArr.reduce((acc, item) => {
    const { timestamp } = item;

    if (!acc[timestamp]) {
      acc[timestamp] = [];
    }

    acc[timestamp].push({
      ...item,
      palletStatus: item.palletStatus || ""
    });

    return acc;
  }, {});
};

export const groupBlockByTimeFrame = (dataArr) => {
  return Object.groupBy(dataArr, ({ timestamp }) => timestamp);
};

export const groupRackByTimeFrame = (dataArr) => {
  return Object.groupBy(dataArr, ({ timestamp }) => timestamp);
};

export const groupProductinLineByTimeFrame = (data) =>
  data.reduce((acc, d) => {
    const t = d.timestamp;
    acc[t] ||= [];
    if (!acc[t].some((e) => e.LINE_NAME === d.LINE_NAME))
      acc[t].push({
        LINE_NAME: d.LINE_NAME,
        ITEM: d.ITEM,
        JOB_NUMBER: d.JOB_NUMBER,
        CASES_SCHEDULED: d.CASES_SCHEDULED,
        CASES_PRODUCED: d.CASES_PRODUCED,
        CASES_REMAINING: d.CASES_REMAINING,
        longitude: d.LONGITUDE,
        latitude: d.LATITUDE,
        FIP: d.FIP,
        LGV: d.LGV,
        PALLETS: d.PALLETS,
        STATION_1: d.STATION_1,
        STATION_2: d.STATION_2
      });
    return acc;
  }, {});

// Function to generate time frames
export const generateTimeFrame = (startTimeString, endTimeString) => {
  let endDtObj = new Date(endTimeString);
  let startDtObj = new Date(startTimeString);
  let timeFrame = [];

  while (startDtObj < endDtObj) {
    timeFrame.push(startDtObj.toISOString());
    startDtObj.setSeconds(startDtObj.getSeconds() + 1);
  }

  return timeFrame;
};

export const getTimeInISOFromZero = (timeObj) => {
  if (timeObj instanceof Date && !isNaN(timeObj)) {
    let fromTimeObj = new Date(timeObj);
    fromTimeObj.setSeconds(0);
    let endTimeObj = new Date(timeObj);
    endTimeObj.setSeconds(0);
    endTimeObj.setMinutes(endTimeObj.getMinutes() + 1);

    return {
      startTime: fromTimeObj.toISOString(),
      endTime: endTimeObj.toISOString()
    };
  } else {
    return null;
  }
};
